{
  "title": "Aid",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level abjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a tiny strip of white cloth)",
  "duration": "8 hours",
  "description": [
    "Your spell bolsters your allies with toughness and resolve. Choose up to three creatures within range. Each target’s hit point maximum and current hit points increase by 5 for the duration.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, a target’s hit points increase by an additional 5 for each slot level above 2nd."
  ],
  "spellLists": ["artificer", "bard", "cleric", "paladin", "ranger"]
}
